import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export const InstallButton = () => {
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);
  if (!prompt) return null;
  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };
  return (
    <button onClick={install} data-testid="install-app-btn"
      className="rounded-full border border-[var(--green)] px-4 py-2.5 font-semibold flex items-center gap-2 hover:bg-[var(--green)] hover:text-[var(--cream)] transition-colors">
      <Download size={16} /> <span className="hidden sm:inline">Install app</span>
    </button>
  );
};
